import { Entity } from '@adornis/baseql/decorators.js';
import { AdornisFile } from '@adornis/file-utils/db/files.js';

@Entity()
export class ResumeReviewFile extends AdornisFile {
  static override _class = 'ResumeReviewFile';
}
